import * as THREE from "three";

export function createLabelSprite(
  text: string,
  color: number,
  size: number,
): THREE.Sprite {
  const canvas = document.createElement("canvas");
  canvas.width = 256;
  canvas.height = 128;
  drawLabel(canvas, text, color);

  const material = new THREE.SpriteMaterial({
    map: new THREE.CanvasTexture(canvas),
    depthTest: false,
    transparent: true,
    toneMapped: false,
  });
  const sprite = new THREE.Sprite(material);
  sprite.scale.set(size * 2, size, 1);
  sprite.renderOrder = 3;
  return sprite;
}

export function updateLabelSprite(
  sprite: THREE.Sprite,
  text: string,
  color: number,
): void {
  const texture = sprite.material.map;
  if (!texture || !(texture.image instanceof HTMLCanvasElement)) return;
  drawLabel(texture.image, text, color);
  texture.needsUpdate = true;
}

export function disposeLabelSprite(sprite: THREE.Sprite): void {
  sprite.material.map?.dispose();
  sprite.material.dispose();
}

function drawLabel(
  canvas: HTMLCanvasElement,
  text: string,
  color: number,
): void {
  const context = canvas.getContext("2d");
  if (!context) return;

  context.clearRect(0, 0, canvas.width, canvas.height);
  context.font = "700 76px Inter, system-ui, sans-serif";
  context.textAlign = "center";
  context.textBaseline = "middle";
  context.lineWidth = 10;
  context.strokeStyle = "rgba(16, 20, 22, 0.92)";
  context.fillStyle = `#${color.toString(16).padStart(6, "0")}`;
  const renderedText = text.replace(/\d/g, (digit) =>
    "₀₁₂₃₄₅₆₇₈₉".charAt(Number(digit)),
  );
  context.strokeText(renderedText, 128, 64);
  context.fillText(renderedText, 128, 64);
}
